import(/* webpackMode: "eager" */ "/app/src/app/products/datapilot/page.tsx");
